import { formatDistance } from 'date-fns';
import { enUS, ro } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import { cn } from '@/utils/utils.ts';
import { useTranslation } from 'react-i18next';

interface LastUpdateTimestampProps {
  updatedAt?: number;
  updateInterval?: number;
  className?: string;
}

export const LastUpdateTimestamp = ({
  updatedAt,
  updateInterval = 10000, // Default to 10 seconds
  className,
}: LastUpdateTimestampProps) => {
  const { i18n } = useTranslation();
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(Date.now());
    }, updateInterval);

    return () => clearInterval(timer);
  }, [updateInterval]);

  return (
    <span className={cn('h-4 text-xs text-muted-foreground', className)}>
      {!updatedAt
        ? '...'
        : formatDistance(updatedAt, currentTime, {
            includeSeconds: true,
            locale: (i18n.language as 'ro' | 'en') === 'ro' ? ro : enUS,
          })}
    </span>
  );
};
